import TextControls from './TextControls';

/**
 * The outermost bounds of the lettering together with drop shadow.
 */
export default class TextOuterControls extends TextControls {
  getX() {
    if (!this.textObject.dropShadow) {
      return this.textObject.x;
    }

    return Math.min(
      this.textObject.x,
      this.textObject.x +
        this.textObject.dropShadow.x -
        this.textObject.dropShadow.width / 2
    );
  }

  getY() {
    if (!this.textObject.dropShadow) {
      return this.textObject.y;
    }

    return Math.min(
      this.textObject.y,
      this.textObject.y +
        this.textObject.dropShadow.y -
        this.textObject.dropShadow.height / 2
    );
  }

  getWidth() {
    return (
      Math.max(
        this.textObject.x +
          this.textObject.foreground.x +
          this.textObject.foreground.width,
        this.textObject.dropShadow
          ? this.textObject.x +
              this.textObject.dropShadow.x +
              this.textObject.dropShadow.width / 2
          : 0
      ) - this.x
    );
  }

  getHeight() {
    return (
      Math.max(
        this.textObject.y +
          this.textObject.foreground.y +
          this.textObject.foreground.height,
        this.textObject.y +
          this.textObject.fontHeight * this.textObject.numLines,
        this.textObject.dropShadow
          ? this.textObject.y +
              this.textObject.dropShadow.y +
              this.textObject.dropShadow.height / 2
          : 0
      ) - this.y
    );
  }
}
